/**
 * 借款相关
 */
export default [
  {
    /**
     * 融资记录
     * https://http.jd.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=630c71aff54b57a7352007e1
     */
    name: 'queryFinanceList',
    method: 'post',
    url: '/finhub/page/finance/loan/list',
  },
  {
    /**
     * 融资单详情
     * https://http.jd.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=630c71f1af50ba51ae0c9d2b
     */
    name: 'financeDetail',
    method: 'post',
    url: '/finhub/page/finance/detail',
  },
  {
    /**
     * 查询关联单
     * http://10.222.95.129/#/view/L2klYL8P
     */
    name: 'financeAssociated',
    method: 'post',
    url: '/finhub/page/finance/associated',
  },
]
